import { Injectable } from '@angular/core';
import { ServiceConfig } from './service-config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class DashboardService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/ipcc/dashboard/';
  private url_report = this.host + '/api/ipcc';

  private httpParams = new HttpParams().set('token', JSON.parse(localStorage.getItem('currentSmmData')).token);
  private httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private httpClient: HttpClient) {

  }
  getSuggestionPost(body): Observable<any> {
    return this.httpClient.post(`${this.url_report}/report/getRecentPost`, body, { params: this.httpParams, headers: this.httpHeaders });
  }
  public searchDashboard(body): Observable<any> {
    let url = this.baseUrl + 'search';
    return this.httpClient.post(url, body, { params: this.httpParams, headers: this.httpHeaders });
  }
  public searchDashboardComment(body): Observable<any> {
    let url = this.baseUrl + 'searchComment';
    return this.httpClient.post(url, body, { params: this.httpParams, headers: this.httpHeaders });
  }

  public getTopHashtag(body): Observable<any> {
    return this.httpClient.post(`${this.url_report}/report/hashtag`, body, { params: this.httpParams, headers: this.httpHeaders });
  }

  public  getSentimentReport(body): Observable<any> {
    return this.httpClient.post(`${this.url_report}/report/outstanding-statistics`, body, { params: this.httpParams, headers: this.httpHeaders });
  }

  public discussion(body): Observable<any> {
    return this.httpClient.post(`${this.url_report}/report/discussion-development-brands`, body, { params: this.httpParams, headers: this.httpHeaders });
  }

  
  public getTrademarkData(body) {
    const url = this.url_report + '/post/getTrademarkData';
    return this.httpClient.post<any>(url, body,{ params: this.httpParams, headers: this.httpHeaders });
  }
  
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/dashboard.service.ts